import React from "react";

const SvgComment = ({ color, ...props }) => (
  <svg width="16" viewBox="0 0 16 16" {...props}>
    <defs>
      <path
        id="comment_svg"
        d="M646.436 1639.936s-1.769-.53-3.02-.53c-1.036 0-1.273.21-2.448.21-4.067 0-7.372-3.002-7.886-6.714-.664-4.798 3.122-8.9 7.886-8.9 3.922.001 7.045 2.725 7.78 6.128a7.726 7.726 0 0 1-.082 3.67c-.25.926-.198 1.905.044 2.834l.222.855c.386 1.48-.986 2.825-2.496 2.447zm.726-2.9c-.33-1.265-.343-2.53-.04-3.654a6.116 6.116 0 0 0 .064-2.914c-.585-2.703-3.065-4.866-6.218-4.866-3.749 0-6.839 3.198-6.302 7.08.405 2.926 3.04 5.334 6.302 5.334 1 0 1.27-.209 2.448-.209 1.445 0 3.537.594 3.537.594.688 0 .378-.717.21-1.364zm-8.66-5.082a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0zm3.998 0a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0zm3.998 0a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0z"
      />
    </defs>
    <use
      fill={color || "currentColor"}
      xlinkHref="#comment_svg"
      transform="translate(-633 -1624)"
    />
  </svg>
);

export default SvgComment;
